import { render } from "./PrintInvoiceWordsDesign2.vue?vue&type=template&id=58235170&scoped=true"
import script from "./PrintInvoiceWordsDesign2.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceWordsDesign2.vue?vue&type=script&lang=js"

import "./PrintInvoiceWordsDesign2.vue?vue&type=style&index=0&id=58235170&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58235170"]])

export default __exports__